import { render } from "./ProtokolAnschauen.vue?vue&type=template&id=a2c338f2&scoped=true"
import script from "./ProtokolAnschauen.vue?vue&type=script&lang=js"
export * from "./ProtokolAnschauen.vue?vue&type=script&lang=js"

import "./ProtokolAnschauen.vue?vue&type=style&index=0&id=a2c338f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c338f2"]])

export default __exports__